import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackAndSend } from "../lib/metaEvents";

/**
 * Fires a PageView (browser Pixel + server CAPI) whenever the pathname changes.
 * Guards against React StrictMode double-mount in dev.
 */
export default function PageViewTracker() {
  const { pathname } = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (lastPathRef.current === pathname) return;
    lastPathRef.current = pathname;
    trackAndSend("PageView", { path: pathname });
  }, [pathname]);

  return null;
}
